
//  liquid vars 
const { cta_url, cup_1_exit, cup_2_exit, cup_3_exit } = window.cupGameData;

function validateLiquidData() {
  if (!window.cupGameData) {
      console.warn('Error: window.cupGameData is not defined.');
      return false;
  }

  if (typeof cta_url !== 'string' || cta_url.trim() === '') {
      console.warn('Error: cta_url is missing or invalid.');
      return false;
  }

  if (typeof cup_1_exit !== 'string' || cup_1_exit.trim() === '') {
      console.warn('Error: cup_1_exit is missing or invalid.');
      return false;
  }
  
  if (typeof cup_2_exit !== 'string' || cup_2_exit.trim() === '') {
      console.warn('Error: cup_2_exit is missing or invalid.');
      return false;
  }
  if (typeof cup_3_exit !== 'string' || cup_3_exit.trim() === '') {
      console.warn('Error: cup_3_exit is missing or invalid.');
      return false;
  }

  return true;
}

// ===== Config / helpers =====
const HS_STATE = Object.freeze({
  INITIAL: 'initial',
  BASE_PLAYING: 'base-playing',
  BASE_ENDED: 'base-ended',
  OPTION_PLAYING: 'option-playing',
});
let optionVideosLoaded = false;
const optionVideos = [
  {el: document.getElementById('option1-video'), src: '{{ cup_1_exit }}'},
  {el: document.getElementById('option2-video'), src: '{{ cup_2_exit }}'},
  {el: document.getElementById('option3-video'), src: '{{ cup_3_exit }}'}
];

function devLog(...args) { 
  // console.log('[cup-swap]', ...args); 
}

function required(el, name) {
  if (!el) throw new Error(`[cup-swap] missing ${name}`);
  return el;
}

function safePlay(video) {
  devLog('safePlay: video', video)
  return video.play().catch(err => devLog('play() failed:', err));
}

function setZonesActive(container, isActive) {
  if (isActive) container.classList.add('active');
  else container.classList.remove('active');
}

// ===== Module state =====
let state = HS_STATE.INITIAL;
let dom = {
  container: null,
  baseVideo: null,
  zonesContainer: null,
  zones: null,
  options: {}
};

// ===== DOM init =====
function initDOM() {
  dom.container      = required(document.getElementById('game-container'), '#game-container');
  dom.baseVideo      = required(document.getElementById('base-video'), '#base-video');
  dom.zonesContainer = required(document.getElementById('click-zones'), '#click-zones');
  dom.zones          = dom.container.querySelectorAll('[data-zone-option]');
  dom.posterBase = required(dom.container.querySelector('#poster-base'))
  dom.posterOption = required(dom.container.querySelector('#poster-option'))
  if (!dom.zones || dom.zones.length === 0) throw new Error('[cup-swap] no [data-zone-option] zones found');

  dom.options = {
    1: document.getElementById('option1-video'),
    2: document.getElementById('option2-video'),
    3: document.getElementById('option3-video'),
  };

  const missing = Object.entries(dom.options).filter(([, el]) => !el);
  if (missing.length) {
    throw new Error(`[cup-swap] missing option videos: ${missing.map(([k]) => k).join(', ')}`);
  }
}

// ===== UI helpers =====
function hideAll() {
  dom.container.querySelectorAll('video').forEach(v => {
    v.classList.remove('active');   // purely visual; not used for querying
    if (!v.paused) { try { v.pause(); } catch (_) {} }
    v.currentTime = 0;
  });
}

function show(video) { video.classList.add('active'); }

// ===== Behavior =====
function resetHatSwap() {
  hideAll();
  show(dom.baseVideo);
  state = HS_STATE.INITIAL;
  dom.container.setAttribute('data-game-state', HS_STATE.INITIAL)
  setZonesActive(dom.zonesContainer, false);
  devLog('reset complete');
}

function playOption(optionNumber) {
  const selected = dom.options[optionNumber];
  if (!selected) return;

  hideAll();
  state = HS_STATE.OPTION_PLAYING;
  dom.container.setAttribute('data-game-state', HS_STATE.OPTION_PLAYING)
  dom.container.setAttribute('data-winning-option', optionNumber)
  devLog('playing option', optionNumber);
  show(selected);
  safePlay(selected);
  setZonesActive(dom.zonesContainer, false);
  initWinningState();
  selected.addEventListener('ended', () => {
    // stay on selected option; no auto-reset here
    state = HS_STATE.OPTION_PLAYING;
    dom.container.setAttribute('data-game-state', HS_STATE.OPTION_PLAYING)
    dom.container.setAttribute('data-winning-option', optionNumber)
  }, { once: true });
}

function revealPrizes() {
  const prizes = dom.container.querySelectorAll("[data-prize-revealed='false']")
  if (!prizes || prizes.length == 0) {
    console.log('no prizes found to reveal')
    return;
  }
  prizes.forEach(prize => {
    prize.setAttribute('data-prize-revealed', 'true');
  });
}
function initWinningState() {
  dom.container.setAttribute('data-game-over', 'true')
  launchConfetti();

  dom.container.addEventListener('click', () => {
    window.location.href = cta_url; 
  })

  setTimeout(() => {
    revealPrizes();
  }, 500);
}

function hidePlayBtn() {
    const btn = document.getElementById('btn-play-video')
    if (!btn) {
        devLog('no play btn found add #btn-play-video')
    }
    btn.classList.add('hidden')
}

function showPoster(poster) {
  poster.classList.remove('hidden')
}
function hidePosterWithDelay(poster) {
  setTimeout(function() {
    poster.classList.add('hidden')
  }, 30); 

}

function loadOptionVideos() {
  if (optionVideosLoaded) return;
  optionVideosLoaded = true;
  if (!dom.options || dom.options.length == 0) {
    devLog('dom option videos not found', dom.options)
  }
  
  Object.values(dom.options).forEach((video, i) => {
    if (!video.querySelector('source')) {
      const source = document.createElement('source');
      source.src = [cup_1_exit, cup_2_exit, cup_3_exit][i];
      source.type = 'video/mp4';
      video.appendChild(source);
      video.load();
    }
  });

}
function wireEvents() {
  const playBtns = dom.container.querySelectorAll('[data-play-video]');
  devLog('playBtns', playBtns)
  playBtns.forEach(btn => {
      btn.addEventListener('click', () => {
          if (state !== HS_STATE.INITIAL) return;
          state = HS_STATE.BASE_PLAYING;
          triggerConvertEventStartSpin();
          dom.container.setAttribute('data-game-state', HS_STATE.BASE_PLAYING)
          devLog('base video clicked → playing');
          safePlay(dom.baseVideo);
          hidePlayBtn()
          hidePosterWithDelay(dom.posterBase)  
          loadOptionVideos();      
      });
  });


  // When base ends, show zones
  dom.baseVideo.addEventListener('ended', () => {
    if (state !== HS_STATE.BASE_PLAYING) return;
    state = HS_STATE.BASE_ENDED;
    dom.container.setAttribute('data-game-state', HS_STATE.BASE_ENDED)
    setZonesActive(dom.zonesContainer, true);
    devLog('base ended → zones active');
    showPoster(dom.posterOption)
  });

  // Zone clicks
  dom.zones.forEach(zone => {
    zone.addEventListener('click', (e) => {
      if (state !== HS_STATE.BASE_ENDED) return;
      e.stopPropagation();
      const option = parseInt(zone.getAttribute('data-zone-option'), 10);
      playOption(option);
      hidePosterWithDelay(dom.posterOption)
    });
  });
}

function launchConfetti() {
  const confettiCanvas = document.getElementById('confetti-canvas');
  const confettiCtx = confettiCanvas.getContext('2d');
    const pieces = Array.from({length: 100}, () => ({
      x: Math.random() * window.innerWidth,
      y: -20,
      r: Math.random() * 6 + 4,
      d: Math.random() * 4 + 1,
      color: `hsl(${Math.random() * 360}, 100%, 50%)`,
      tilt: Math.random() * 10 - 10,
      stop: false,
    }));

    confettiCanvas.width = window.innerWidth;
    confettiCanvas.height = window.innerHeight;

    function draw() {
      confettiCtx.clearRect(0, 0, confettiCanvas.width, confettiCanvas.height);
      for (let p of pieces) {
        confettiCtx.beginPath();
        confettiCtx.fillStyle = p.color;
        confettiCtx.ellipse(p.x, p.y, p.r, p.r / 2, p.tilt, 0, 2 * Math.PI);
        confettiCtx.fill();
      }
      update();
    }

  function update() {
    for (let p of pieces) {
      if (!p.stop) {
        p.y += p.d;
        p.tilt += 0.1;
        if (p.y > window.innerHeight) p.stop = true;
      }
    }
  }

  let animationFrame;
  function animate() {
    draw();
    animationFrame = requestAnimationFrame(animate);
  }

  animate();

  setTimeout(() => {
    cancelAnimationFrame(animationFrame);
    confettiCtx.clearRect(0, 0, confettiCanvas.width, confettiCanvas.height);
  }, 6000);
}


  function triggerConvertEventStartSpin() {
    window._conv_q = window._conv_q || [];
    _conv_q.push(['triggerConversion', '100331973']);
  }

// ===== Boot =====
document.addEventListener('DOMContentLoaded', () => {
  try {
    initDOM();
    resetHatSwap();
    wireEvents();
    devLog('init complete');
  } catch (err) {
    console.warn(String(err));
  }
});
